import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import * as react from 'react';
import react__default from 'react';
import * as uiLibrary from '@tolk-ai/ui-library-react';
import * as instagram from '@tolk-ai/connectors-config-instagram';
import * as genericUtils from '@tolk-ai/generic-utils';
import * as messenger from '@tolk-ai/connectors-config-messenger';
import classNames from 'classnames';
import * as shopify from '@tolk-ai/account-management-shopify';
import * as shopifyConnectorsConfig from '@tolk-ai/connectors-config-shopify';
import * as uuid from 'uuid';
import * as zendesk from '@tolk-ai/connectors-config-zendesk';

var styles$a = {"connected__instagram-informations":"index-module_connected__instagram-informations__HN6UY"};

const Component$a = ({
  instagramAccountName
}) => jsx("p", Object.assign({
  className: styles$a['connected__instagram-informations']
}, {
  children: instagramAccountName
}), void 0);

var styles$9 = {"connected__describe":"index-module_connected__describe__t7gDj","connected__desribe-link":"index-module_connected__desribe-link__YrGrd","connected__informations":"index-module_connected__informations__PDmDk","connected__status":"index-module_connected__status__lhb4v","connected__instagram-informations":"index-module_connected__instagram-informations__IJ0-I","connected__buttons-container":"index-module_connected__buttons-container__tM-ZN","connected__update-button":"index-module_connected__update-button__M8Hu8","connected__instagram-login-button-icon":"index-module_connected__instagram-login-button-icon__8FmSD","connected__describe-with-link":"index-module_connected__describe-with-link__eZbAJ","connected__visit":"index-module_connected__visit__VH6PP"};

const Component$9 = ({
  instagramAccounts,
  onUpdateClick
}) => jsxs(uiLibrary.PageLayoutContent, {
  children: [jsx(uiLibrary.pageLayout.content.title.Component, {
    children: "Set your app"
  }, void 0), jsx(uiLibrary.pageLayout.content.describe.Component, {
    children: jsxs("span", Object.assign({
      className: styles$9.connected__describe
    }, {
      children: ["Log with Facebook to connect your assistant to Instagram. ", jsx("br", {}, void 0), ' ', jsxs("span", Object.assign({
        className: styles$9['connected__describe-with-link']
      }, {
        children: [jsx("span", Object.assign({
          className: styles$9.connected__visit
        }, {
          children: "If you need guidance, consider visit"
        }), void 0), ' ', jsx(uiLibrary.ExternalLink, Object.assign({
          url: "https://academy.tolk.ai/kb/fr"
        }, {
          children: "our help center"
        }), void 0)]
      }), void 0)]
    }), void 0)
  }, void 0), jsxs("div", Object.assign({
    className: styles$9.connected__informations
  }, {
    children: [jsx("strong", Object.assign({
      className: styles$9.connected__status
    }, {
      children: "Account connected"
    }), void 0), instagramAccounts.map(instagramAccount => jsx(Component$a, {
      instagramAccountName: instagramAccount.name
    }, instagramAccount.name))]
  }), void 0), jsx("div", Object.assign({
    className: styles$9['connected__buttons-container']
  }, {
    children: jsx(uiLibrary.Button, Object.assign({
      className: styles$9['connected__update-button'],
      icon: {
        className: styles$9['connected__instagram-login-button-icon'],
        name: 'instagram',
        position: 'left-icon'
      },
      onClick: onUpdateClick
    }, {
      children: "Update preference"
    }), void 0)
  }), void 0)]
}, void 0);

var styles$8 = {"disconnected__describe":"index-module_disconnected__describe__SlqT9","disconnected__describe-with-link":"index-module_disconnected__describe-with-link__ePgiW","disconnected__visit":"index-module_disconnected__visit__Adksr","disconnected__instagram-login-button":"index-module_disconnected__instagram-login-button__BdHVx","disconnected__instagram-login-button-icon":"index-module_disconnected__instagram-login-button-icon__QgjOl"};

const Component$8 = ({
  onClick
}) => jsxs(uiLibrary.PageLayoutContent, {
  children: [jsx(uiLibrary.pageLayout.content.title.Component, {
    children: "Set your app"
  }, void 0), jsx(uiLibrary.pageLayout.content.describe.Component, {
    children: jsxs("span", Object.assign({
      className: styles$8.disconnected__describe
    }, {
      children: ["Log with Facebook to connect your assistant to Instagram. ", jsx("br", {}, void 0), ' ', jsxs("span", Object.assign({
        className: styles$8['disconnected__describe-with-link']
      }, {
        children: [jsx("span", Object.assign({
          className: styles$8.disconnected__visit
        }, {
          children: "If you need guidance, consider visit"
        }), void 0), ' ', jsx(uiLibrary.ExternalLink, Object.assign({
          url: "https://academy.tolk.ai/kb/fr"
        }, {
          children: "our help center"
        }), void 0)]
      }), void 0)]
    }), void 0)
  }, void 0), jsx(uiLibrary.Button, Object.assign({
    className: styles$8['disconnected__instagram-login-button'],
    icon: {
      className: styles$8['disconnected__instagram-login-button-icon'],
      name: 'instagram',
      position: 'left-icon'
    },
    onClick: onClick
  }, {
    children: "Connect Instagram"
  }), void 0)]
}, void 0);

var styles$7 = {"loading":"index-module_loading__DREhc","loading__icon":"index-module_loading__icon__glAbt"};

const Component$7 = () => jsx(uiLibrary.PageLayoutContent, {
  children: jsx("div", Object.assign({
    className: styles$7.loading
  }, {
    children: jsx(uiLibrary.icon.Component, {
      className: styles$7.loading__icon,
      icon: "spinner"
    }, void 0)
  }), void 0)
}, void 0);

const onInit$2 = async (botId, getOneInstagramChannelConfig, setFeedback, setIsLoading, setState) => {
  setIsLoading(true);

  try {
    const result = await getOneInstagramChannelConfig(botId);

    if (genericUtils.isDomainError(result, instagram.appPorts.GetOneInstagramChannelConfigErrors)) {
      switch (result) {
        case instagram.appPorts.GetOneInstagramChannelConfigErrors.inexistingInstagramChannelConfig:
          setState({
            state: 'disconnected'
          });
          setIsLoading(false);
          break;

        default:
      }

      return;
    }

    setState({
      instagramAccounts: result.pagesConfig,
      state: 'connected'
    });
    setIsLoading(false);
  } catch (_a) {
    setIsLoading(false);
    setFeedback('An error occured, please retry');
  }
};

const onLoginButtonClick$2 = (botId, createOneInstagramLoginConfig, setFeedback, window) => async () => {
  try {
    const result = await createOneInstagramLoginConfig(botId);

    if (genericUtils.isDomainError(result, instagram.appPorts.CreateOneInstagramLoginConfigErrors)) {
      switch (result) {
        case instagram.appPorts.CreateOneInstagramLoginConfigErrors.inexistingBot:
          setFeedback('An error occured, please retry');
          break;

        default:
      }

      return;
    }

    window.location.assign(result.url);
  } catch (_a) {
    setFeedback('An error occured, please retry');
  }
};

const onUpdateButtonClick$1 = (botId, createOneInstagramLoginConfig, setFeedback, window) => async () => {
  try {
    const result = await createOneInstagramLoginConfig(botId);

    if (genericUtils.isDomainError(result, instagram.appPorts.CreateOneInstagramLoginConfigErrors)) {
      switch (result) {
        case instagram.appPorts.CreateOneInstagramLoginConfigErrors.inexistingBot:
          break;

        default:
      }

      return;
    }

    window.location.assign(result.url);
  } catch (_a) {
    setFeedback('An error occured, please retry');
  }
};

const container$3 = (createOneInstagramLoginConfig, getOneInstagramChannelConfig, window) => ({
  botId
}) => {
  const [feedback, setFeedback] = react.useState('');
  const [state, setState] = react.useState({
    state: 'disconnected'
  });
  const [isLoading, setIsLoading] = react.useState(true);
  react.useEffect(() => {
    void onInit$2(botId, getOneInstagramChannelConfig, setFeedback, setIsLoading, setState);
  }, []);
  return jsxs(Fragment, {
    children: [feedback !== '' && jsx(uiLibrary.toast.Container, Object.assign({
      autoHide: {
        delay: 5000,
        isActive: true,
        onHide: () => setFeedback('')
      },
      position: {
        location: 'bottom-left'
      },
      type: "danger"
    }, {
      children: feedback
    }), void 0), isLoading && jsx(Component$7, {}, void 0), state.state === 'disconnected' && !isLoading && jsx(Component$8, {
      onClick: onLoginButtonClick$2(botId, createOneInstagramLoginConfig, setFeedback, window)
    }, void 0), state.state === 'connected' && !isLoading && jsx(Component$9, {
      instagramAccounts: state.instagramAccounts,
      onUpdateClick: onUpdateButtonClick$1(botId, createOneInstagramLoginConfig, setFeedback, window)
    }, void 0)]
  }, void 0);
};

var index$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  container: container$3
});

var styles$6 = {"connected__messenger-informations":"index-module_connected__messenger-informations__YSGBR"};

const Component$6 = ({
  messengerAccountName
}) => jsx("p", Object.assign({
  className: styles$6['connected__messenger-informations']
}, {
  children: messengerAccountName
}), void 0);

var styles$5 = {"connected__describe":"index-module_connected__describe__lTuiM","connected__desribe-link":"index-module_connected__desribe-link__3UP4e","connected__informations":"index-module_connected__informations__xcZrG","connected__status":"index-module_connected__status__n2Kui","connected__messenger-informations":"index-module_connected__messenger-informations__Xx9so","connected__buttons-container":"index-module_connected__buttons-container__ePbzH","connected__update-button":"index-module_connected__update-button__aAW8s","connected__messenger-login-button-icon":"index-module_connected__messenger-login-button-icon__StLbh","connected__describe-with-link":"index-module_connected__describe-with-link__euqn2","connected__visit":"index-module_connected__visit__DCNxs"};

const Component$5 = ({
  messengerAccounts,
  onUpdateClick
}) => jsxs(uiLibrary.PageLayoutContent, {
  children: [jsx(uiLibrary.pageLayout.content.title.Component, {
    children: "Set your app"
  }, void 0), jsx(uiLibrary.pageLayout.content.describe.Component, {
    children: jsxs("span", Object.assign({
      className: styles$5.connected__describe
    }, {
      children: ["Log with Facebook to connect your assistant to Messenger. ", jsx("br", {}, void 0), ' ', jsxs("span", Object.assign({
        className: styles$5['connected__describe-with-link']
      }, {
        children: [jsx("span", Object.assign({
          className: styles$5.connected__visit
        }, {
          children: "If you need guidance, consider visit"
        }), void 0), ' ', jsx(uiLibrary.ExternalLink, Object.assign({
          url: "https://academy.tolk.ai/kb/fr"
        }, {
          children: "our help center"
        }), void 0)]
      }), void 0)]
    }), void 0)
  }, void 0), jsxs("div", Object.assign({
    className: styles$5.connected__informations
  }, {
    children: [jsx("strong", Object.assign({
      className: styles$5.connected__status
    }, {
      children: "Account connected"
    }), void 0), messengerAccounts.map(messengerAccount => jsx(Component$6, {
      messengerAccountName: messengerAccount.name
    }, messengerAccount.name))]
  }), void 0), jsx("div", Object.assign({
    className: styles$5['connected__buttons-container']
  }, {
    children: jsx(uiLibrary.Button, Object.assign({
      className: styles$5['connected__update-button'],
      onClick: onUpdateClick
    }, {
      children: "Update preference"
    }), void 0)
  }), void 0)]
}, void 0);

var styles$4 = {"disconnected__describe":"index-module_disconnected__describe__esa13","disconnected__messenger-login-button-icon":"index-module_disconnected__messenger-login-button-icon__bA8zU","disconnected__describe-with-link":"index-module_disconnected__describe-with-link__jaKOq","disconnected__messenger-login-button":"index-module_disconnected__messenger-login-button__tNov2","disconnected__visit":"index-module_disconnected__visit__UWn9i"};

const Component$4 = ({
  onClick
}) => jsxs(uiLibrary.PageLayoutContent, {
  children: [jsx(uiLibrary.pageLayout.content.title.Component, {
    children: "Set your app"
  }, void 0), jsx(uiLibrary.pageLayout.content.describe.Component, {
    children: jsxs("span", Object.assign({
      className: styles$4.disconnected__describe
    }, {
      children: ["Log with Facebook to connect your assistant to Messenger. ", jsx("br", {}, void 0), ' ', jsxs("span", Object.assign({
        className: styles$4['disconnected__describe-with-link']
      }, {
        children: [jsx("span", Object.assign({
          className: styles$4.disconnected__visit
        }, {
          children: "If you need guidance, consider visit"
        }), void 0), ' ', jsx(uiLibrary.ExternalLink, Object.assign({
          url: "https://academy.tolk.ai/kb/fr"
        }, {
          children: "our help center"
        }), void 0)]
      }), void 0)]
    }), void 0)
  }, void 0), jsx(uiLibrary.Button, Object.assign({
    className: styles$4['disconnected__messenger-login-button'],
    onClick: onClick
  }, {
    children: "Connect Messenger"
  }), void 0)]
}, void 0);

var styles$3 = {"loading":"index-module_loading__ILQTK","loading__icon":"index-module_loading__icon__R2e-X"};

const Component$3 = () => jsx(uiLibrary.PageLayoutContent, {
  children: jsx("div", Object.assign({
    className: styles$3.loading
  }, {
    children: jsx(uiLibrary.icon.Component, {
      className: styles$3.loading__icon,
      icon: "spinner"
    }, void 0)
  }), void 0)
}, void 0);

const onInit$1 = async (botId, getOneMessengerChannelConfig, setFeedback, setIsLoading, setState) => {
  setIsLoading(true);

  try {
    const result = await getOneMessengerChannelConfig(botId);

    if (genericUtils.isDomainError(result, messenger.appPorts.GetOneMessengerChannelConfigErrors)) {
      switch (result) {
        case messenger.appPorts.GetOneMessengerChannelConfigErrors.inexistingMessengerChannelConfig:
          setState({
            state: 'disconnected'
          });
          setIsLoading(false);
          break;

        default:
      }

      return;
    }

    setState({
      messengerAccounts: result.pagesConfig,
      state: 'connected'
    });
    setIsLoading(false);
  } catch (_a) {
    setIsLoading(false);
    setFeedback('An error occured, please retry');
  }
};

const onLoginButtonClick$1 = (botId, createOneMessengerLoginConfig, setFeedback, window) => async () => {
  try {
    const result = await createOneMessengerLoginConfig(botId);

    if (genericUtils.isDomainError(result, messenger.appPorts.CreateOneMessengerLoginConfigErrors)) {
      switch (result) {
        case messenger.appPorts.CreateOneMessengerLoginConfigErrors.inexistingBot:
          setFeedback('An error occured, please retry');
          break;

        default:
      }

      return;
    }

    window.location.assign(result.url);
  } catch (_a) {
    setFeedback('An error occured, please retry');
  }
};

const onUpdateButtonClick = (botId, createOneMessengerLoginConfig, setFeedback, window) => async () => {
  try {
    const result = await createOneMessengerLoginConfig(botId);

    if (genericUtils.isDomainError(result, messenger.appPorts.CreateOneMessengerLoginConfigErrors)) {
      switch (result) {
        case messenger.appPorts.CreateOneMessengerLoginConfigErrors.inexistingBot:
          break;

        default:
      }

      return;
    }

    window.location.assign(result.url);
  } catch (_a) {
    setFeedback('An error occured, please retry');
  }
};

const container$2 = (createOneMessengerLoginConfig, getOneMessengerChannelConfig, window) => ({
  botId
}) => {
  const [feedback, setFeedback] = react.useState('');
  const [state, setState] = react.useState({
    state: 'disconnected'
  });
  const [isLoading, setIsLoading] = react.useState(true);
  react.useEffect(() => {
    void onInit$1(botId, getOneMessengerChannelConfig, setFeedback, setIsLoading, setState);
  }, []);
  return jsxs(Fragment, {
    children: [feedback !== '' && jsx(uiLibrary.toast.Container, Object.assign({
      autoHide: {
        delay: 5000,
        isActive: true,
        onHide: () => setFeedback('')
      },
      position: {
        location: 'bottom-left'
      },
      type: "danger"
    }, {
      children: feedback
    }), void 0), isLoading && jsx(Component$3, {}, void 0), state.state === 'disconnected' && !isLoading && jsx(Component$4, {
      onClick: onLoginButtonClick$1(botId, createOneMessengerLoginConfig, setFeedback, window)
    }, void 0), state.state === 'connected' && !isLoading && jsx(Component$5, {
      messengerAccounts: state.messengerAccounts,
      onUpdateClick: onUpdateButtonClick(botId, createOneMessengerLoginConfig, setFeedback, window)
    }, void 0)]
  }, void 0);
};

var index$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  container: container$2
});

var styles$2 = {"connected__describe":"index-module_connected__describe__FgcAw","connected__footer":"index-module_connected__footer__jOxYy","connected__informations":"index-module_connected__informations__TNye-","connected__status":"index-module_connected__status__CKrM6","connected__shop-name":"index-module_connected__shop-name__n7cCb","connected__steps":"index-module_connected__steps__UNffo","step__one":"index-module_step__one__-eSBZ","step__two":"index-module_step__two__GCWi-","step__three":"index-module_step__three__rbPEk","connected__shopify-logout-button":"index-module_connected__shopify-logout-button__QwCs2","connected__shopify-logout-button-icon":"index-module_connected__shopify-logout-button-icon__7DGsU","connected__link-step-one":"index-module_connected__link-step-one__uRi-x","connected__link-step-two":"index-module_connected__link-step-two__vbO-S","connected__link-step-three":"index-module_connected__link-step-three__4W9g1","connected__content-in-step-one":"index-module_connected__content-in-step-one__MzyAM","connected__content-in-step-two":"index-module_connected__content-in-step-two__TnqRJ","connected__content-in-step-three":"index-module_connected__content-in-step-three__Pu2Kw","connected__content-footer":"index-module_connected__content-footer__M1Pv4"};

const Component$2 = ({
  onClick,
  shopName
}) => jsxs(uiLibrary.PageLayoutContent, {
  children: [jsx(uiLibrary.pageLayout.content.title.Component, {
    children: "Set your app"
  }, void 0), jsx(uiLibrary.pageLayout.content.describe.Component, {
    children: jsxs("span", Object.assign({
      className: styles$2.connected__describe
    }, {
      children: ["To be able to display our chat widget, we use an app embed block that allow us to embed dynamically our chat script into your Shopify theme.", ' ', jsx("br", {}, void 0), " Now we can display our chat widget in your theme without installing anything, linked to your assistant that is here to handle support questions automatically and help conversions."]
    }), void 0)
  }, void 0), jsxs("div", Object.assign({
    className: classNames( // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    styles$2.connected__informations, 'text-regular-base-dark')
  }, {
    children: [jsx("strong", Object.assign({
      className: styles$2.connected__status
    }, {
      children: "Account connected"
    }), void 0), jsxs("p", Object.assign({
      className: styles$2['connected__shop-name']
    }, {
      children: [shopName, ".shopify.com"]
    }), void 0), jsxs("ul", Object.assign({
      className: styles$2.connected__steps
    }, {
      children: [jsxs("li", Object.assign({
        className: styles$2.step__one
      }, {
        children: [jsx("p", {
          children: "Verify your bot content and design"
        }, void 0), jsxs("p", Object.assign({
          className: styles$2['connected__link-step-one']
        }, {
          children: [jsx("span", Object.assign({
            className: styles$2['connected__content-in-step-one']
          }, {
            children: "Access bot answers from"
          }), void 0), jsx(uiLibrary.ExternalLink, Object.assign({
            url: "https://bot.tolk.ai/qa"
          }, {
            children: "Q&A"
          }), void 0), jsx("span", Object.assign({
            className: styles$2['connected__content-in-step-one']
          }, {
            children: ", and widget settings from"
          }), void 0), jsx(uiLibrary.ExternalLink, Object.assign({
            url: "https://bot.tolk.ai/webchat"
          }, {
            children: "Design"
          }), void 0)]
        }), void 0)]
      }), void 0), jsxs("li", Object.assign({
        className: styles$2.step__two
      }, {
        children: [jsx("p", {
          children: "Check order tracking feature"
        }, void 0), jsxs("p", Object.assign({
          className: styles$2['connected__link-step-two']
        }, {
          children: [jsx("span", Object.assign({
            className: styles$2['connected__content-in-step-two']
          }, {
            children: "Follow the instructions from"
          }), void 0), jsx(uiLibrary.ExternalLink, Object.assign({
            url: "https://academy.tolk.ai/kb/guide/en/shopify-AXe8ikVs7B/Steps/874154"
          }, {
            children: "our documentation"
          }), void 0)]
        }), void 0)]
      }), void 0), jsxs("li", Object.assign({
        className: styles$2.step__three
      }, {
        children: [jsx("p", {
          children: "Verify your widget visibilty"
        }, void 0), jsxs("p", Object.assign({
          className: styles$2['connected__link-step-three']
        }, {
          children: [jsx("span", Object.assign({
            className: styles$2['connected__content-in-step-three']
          }, {
            children: "You can configure in"
          }), void 0), jsx(uiLibrary.ExternalLink, Object.assign({
            url: "https://bot.tolk.ai/webchat"
          }, {
            children: "Tolk design settings"
          }), void 0), "the appearance of the widget and its visibility.", jsx("span", Object.assign({
            className: styles$2['connected__content-in-step-three']
          }, {
            children: "To activate the widget from the Shopify theme editor,"
          }), void 0), jsx(uiLibrary.ExternalLink, Object.assign({
            url: "https://academy.tolk.ai/kb/guide/en/shopify-AXe8ikVs7B/Steps/874154,874159"
          }, {
            children: "follow those instructions"
          }), void 0), "or watch the video below:"]
        }), void 0)]
      }), void 0)]
    }), void 0), jsx("iframe", {
      allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;",
      allowFullScreen: true,
      frameBorder: "0",
      height: "315",
      src: "https://www.youtube.com/embed/Ce6ZPfTcG7I?modestbranding=1&rel=0",
      title: "YouTube video player",
      width: "560"
    }, void 0)]
  }), void 0), jsxs("p", Object.assign({
    className: classNames( // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    styles$2.connected__footer, 'text-regular-base-dark')
  }, {
    children: [jsx("span", Object.assign({
      className: styles$2['connected__content-footer']
    }, {
      children: "Need to deactivate the widget, toggle off the app"
    }), void 0), jsx(uiLibrary.ExternalLink, Object.assign({
      url: "https://help.shopify.com/en/manual/online-store/themes/extend/apps"
    }, {
      children: "from your Shopify theme editor"
    }), void 0), "and disconnect the Shopify connection."]
  }), void 0), jsx(uiLibrary.Button, Object.assign({
    className: styles$2['connected__shopify-logout-button'],
    icon: {
      className: styles$2['connected__shopify-logout-button-icon'],
      name: 'shopify',
      position: 'left-icon'
    },
    onClick: onClick
  }, {
    children: "Disconnect"
  }), void 0)]
}, void 0);

var styles$1 = {"disconnected__describe":"index-module_disconnected__describe__ofBjv","disconnected__input-container":"index-module_disconnected__input-container__ydrsH","disconnected__shopify-login-button":"index-module_disconnected__shopify-login-button__5QLGq","disconnected__shopify-login-button-icon":"index-module_disconnected__shopify-login-button-icon__rHRMZ","disconnected__describe-with-link":"index-module_disconnected__describe-with-link__Q2vNC","disconnected__visit":"index-module_disconnected__visit__YOnib"};

const Component$1 = ({
  onClick
}) => jsxs(uiLibrary.PageLayoutContent, {
  children: [jsx(uiLibrary.pageLayout.content.title.Component, {
    children: "Set your app"
  }, void 0), jsx(uiLibrary.pageLayout.content.describe.Component, {
    children: jsxs("span", Object.assign({
      className: styles$1.disconnected__describe
    }, {
      children: ["Log with Shopify to connect your assistant to Shopify. ", jsx("br", {}, void 0), jsxs("span", Object.assign({
        className: styles$1['disconnected__describe-with-link']
      }, {
        children: [jsx("span", Object.assign({
          className: styles$1.disconnected__visit
        }, {
          children: "If you need guidance, consider visit"
        }), void 0), ' ', jsx(uiLibrary.ExternalLink, Object.assign({
          url: "https://academy.tolk.ai/kb/guide/en/shopify-AXe8ikVs7B/Steps/874154"
        }, {
          children: "our help center"
        }), void 0)]
      }), void 0)]
    }), void 0)
  }, void 0), jsx(uiLibrary.Button, Object.assign({
    className: styles$1['disconnected__shopify-login-button'],
    icon: {
      className: styles$1['disconnected__shopify-login-button-icon'],
      name: 'shopify',
      position: 'left-icon'
    },
    onClick: onClick
  }, {
    children: "Log with Shopify"
  }), void 0)]
}, void 0);

const onInitWithoutShopId = async (botId, getOneShopInfosByBotId, setFeedback, setState) => {
  try {
    const shopInfos = await getOneShopInfosByBotId(botId);

    if (genericUtils.isDomainError(shopInfos, shopify.appPorts.GetOneShopInfosErrors)) {
      switch (shopInfos) {
        case shopify.appPorts.GetOneShopInfosErrors.inexistingShopInfos:
          setState({
            state: 'disconnected'
          });
          break;

        default:
      }

      return;
    }

    setState({
      shopId: shopInfos.id,
      shopName: shopInfos.shopName,
      state: 'connected'
    });
  } catch (_a) {
    setState({
      state: 'disconnected'
    });
    setFeedback('An error occured, please retry');
  }
};

const onInitWithShopId = async (botId, shopId, connectOneBotToShopInfo, setFeedback, setState) => {
  try {
    const shopInfos = await connectOneBotToShopInfo(shopId, botId);

    if (genericUtils.isDomainError(shopInfos, shopifyConnectorsConfig.appPorts.ConnectOneBotToShopInfoErrors)) {
      switch (shopInfos) {
        case shopifyConnectorsConfig.appPorts.ConnectOneBotToShopInfoErrors.inexistingShopInfo:
        case shopifyConnectorsConfig.appPorts.ConnectOneBotToShopInfoErrors.scriptTagShopifyNotInserted:
          setState({
            state: 'disconnected'
          });
          break;

        default:
      }

      return;
    }

    setState({
      shopId: shopInfos.id,
      shopName: shopInfos.shopName,
      state: 'connected'
    });
  } catch (_a) {
    setState({
      state: 'disconnected'
    });
    setFeedback('An error occured, please retry');
  }
};

const onLoginButtonClick = window => () => {
  window.location.assign('https://apps.shopify.com/tolk-ai');
};

const onLogoutButtonClick = (window, shopId, shopifyAppName) => () => {
  window.location.assign(`https://${shopId}.myshopify.com/admin/app_installations/app/${shopifyAppName}`);
};

const onError$1 = setFeedback => error => {
  switch (error) {
    case 'existingShopInfos':
      setFeedback('Le shop est déjà connecté sur un autre bot');
      break;

    case 'appAlreadyInstalled':
      setFeedback("L'application Tolk est déjà installée sur cette boutique");
      break;
  }
};

const container$1 = (getOneShopInfosByBotId, connectOneBotToShopInfo, window, shopifyAppName) => ({
  botId
}) => {
  const urlParameters = new URLSearchParams(window.location.search);
  const error = urlParameters.get('error');
  const shopId = urlParameters.get('shopId');
  const [feedback, setFeedback] = react.useState('');
  const [state, setState] = react.useState({
    state: 'disconnected'
  });
  react__default.useEffect(() => {
    if (error !== null) {
      void onError$1(setFeedback)(error);
    }

    if (genericUtils.isString(shopId)) {
      void onInitWithShopId(botId, shopId, connectOneBotToShopInfo, setFeedback, setState);
      return;
    }

    void onInitWithoutShopId(botId, getOneShopInfosByBotId, setFeedback, setState);
  }, [botId, shopId, error, setFeedback, setState]);
  return jsxs(Fragment, {
    children: [feedback !== '' && jsx(uiLibrary.toast.Container, Object.assign({
      autoHide: {
        delay: 5000,
        isActive: true,
        onHide: () => setFeedback('')
      },
      position: {
        location: 'bottom-left'
      },
      type: "danger"
    }, {
      children: feedback
    }), void 0), state.state === 'disconnected' && jsx(Component$1, {
      onClick: onLoginButtonClick(window)
    }, void 0), state.state === 'connected' && jsx(Component$2, {
      onClick: onLogoutButtonClick(window, state.shopId, shopifyAppName),
      shopName: state.shopName
    }, void 0)]
  }, void 0);
};

var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  container: container$1
});

var styles = {"form":"index-module_form__omXAz","form__header":"index-module_form__header__bjvvY","form__description":"index-module_form__description__gwXA7","zendesk-form__container":"index-module_zendesk-form__container__xCrEw","zendesk-form__label":"index-module_zendesk-form__label__ogy5s","zendesk-form__input-container":"index-module_zendesk-form__input-container__3m1jk","zendesk-form__input":"index-module_zendesk-form__input__slx3r","zendesk-form__input-domain":"index-module_zendesk-form__input-domain__L4GH5","zendesk-form__button":"index-module_zendesk-form__button__JQOFp","zendesk-form__error-message":"index-module_zendesk-form__error-message__ogQSD","button__logo":"index-module_button__logo__KaN-4","button__label":"index-module_button__label__h2m4z"};

const Component = ({
  subdomain,
  errorMessage,
  mode,
  onSubmit,
  onSubdomainChange,
  onDisconnect
}) => jsxs("section", Object.assign({
  className: styles.form
}, {
  children: [jsx("h1", Object.assign({
    className: styles.form__header
  }, {
    children: "Set your app"
  }), void 0), jsxs("p", Object.assign({
    className: styles.form__description
  }, {
    children: ["Complete this form to connect your assistant to Zendesk. ", jsx("br", {}, void 0), "If you need guidance, consider", ' ', jsx("a", Object.assign({
      href: "https://academy.tolk.ai/kb/fr",
      rel: "noreferrer",
      target: "_blank"
    }, {
      children: "visit our help center"
    }), void 0), "."]
  }), void 0), mode === 'disconnected' && jsxs("form", Object.assign({
    action: "",
    onSubmit: onSubmit
  }, {
    children: [jsx("div", Object.assign({
      className: styles['zendesk-form__container']
    }, {
      children: jsxs("label", Object.assign({
        className: styles['zendesk-form__label'],
        htmlFor: "subdomain"
      }, {
        children: ["URL of your Zendesk*", jsxs("div", Object.assign({
          className: styles['zendesk-form__input-container']
        }, {
          children: [jsx("input", {
            className: styles['zendesk-form__input'],
            id: "subdomain",
            onChange: onSubdomainChange,
            placeholder: "Ex: tolkai",
            type: "text",
            value: subdomain
          }, void 0), jsx("p", Object.assign({
            className: styles['zendesk-form__input-domain']
          }, {
            children: ".zendesk.com"
          }), void 0)]
        }), void 0)]
      }), void 0)
    }), void 0), errorMessage.length > genericUtils.STRING.EMPTY_LENGTH && jsx("p", Object.assign({
      className: styles['zendesk-form__error-message']
    }, {
      children: errorMessage
    }), void 0), jsxs("button", Object.assign({
      className: styles['zendesk-form__button'],
      type: "submit"
    }, {
      children: [jsxs("svg", Object.assign({
        className: styles.button__logo,
        version: "1.1",
        viewBox: "0 0 157 119",
        xmlns: "http://www.w3.org/2000/svg"
      }, {
        children: [jsx("title", {
          children: "Artboard"
        }, void 0), jsx("g", Object.assign({
          fill: "none",
          fillRule: "evenodd",
          id: "Artboard",
          transform: "translate(-23,-42)"
        }, {
          children: jsx("g", Object.assign({
            fill: "#03363d",
            fillRule: "nonzero",
            id: "Zendesk_logo",
            transform: "translate(23,42)"
          }, {
            children: jsx("path", {
              d: "m72.519 31.424v87.568h-72.519zm0-31.424c0 20.029-16.234 36.266-36.259 36.266s-36.259-16.237-36.259-36.266zm11.947 119c0-20.029 16.234-36.266 36.259-36.266s36.259 16.237 36.259 36.266zm0-31.424v-87.576h72.534l-72.534 87.568z",
              id: "Shape"
            }, void 0)
          }), void 0)
        }), void 0)]
      }), void 0), jsx("span", Object.assign({
        className: styles.button__label
      }, {
        children: "Login with Zendesk"
      }), void 0)]
    }), void 0)]
  }), void 0), mode === 'connected' && jsxs("form", Object.assign({
    action: "",
    onSubmit: onDisconnect
  }, {
    children: [errorMessage.length > genericUtils.STRING.EMPTY_LENGTH && jsx("p", Object.assign({
      className: styles['zendesk-form__error-message']
    }, {
      children: errorMessage
    }), void 0), jsxs("button", Object.assign({
      className: styles['zendesk-form__button'],
      type: "submit"
    }, {
      children: [jsxs("svg", Object.assign({
        className: styles.button__logo,
        version: "1.1",
        viewBox: "0 0 157 119",
        xmlns: "http://www.w3.org/2000/svg"
      }, {
        children: [jsx("title", {
          children: "Artboard"
        }, void 0), jsx("g", Object.assign({
          fill: "none",
          fillRule: "evenodd",
          id: "Artboard",
          transform: "translate(-23,-42)"
        }, {
          children: jsx("g", Object.assign({
            fill: "#03363d",
            fillRule: "nonzero",
            id: "Zendesk_logo",
            transform: "translate(23,42)"
          }, {
            children: jsx("path", {
              d: "m72.519 31.424v87.568h-72.519zm0-31.424c0 20.029-16.234 36.266-36.259 36.266s-36.259-16.237-36.259-36.266zm11.947 119c0-20.029 16.234-36.266 36.259-36.266s36.259 16.237 36.259 36.266zm0-31.424v-87.576h72.534l-72.534 87.568z",
              id: "Shape"
            }, void 0)
          }), void 0)
        }), void 0)]
      }), void 0), jsx("span", Object.assign({
        className: styles.button__label
      }, {
        children: "Disconnect"
      }), void 0)]
    }), void 0)]
  }), void 0)]
}), void 0);

const onInit = (getOneZendeskLoginConfigConnected, setMode, setStatusErrorMessage) => async botId => {
  try {
    const result = await getOneZendeskLoginConfigConnected(botId);

    if (genericUtils.isDomainError(result, zendesk.appPorts.GetOneZendeskLoginConfigConnectedErrors)) {
      switch (result) {
        case zendesk.appPorts.GetOneZendeskLoginConfigConnectedErrors.inexistingZendeskLoginConfigConnected:
          setMode('disconnected');
          break;

        default:
      }

      return;
    }

    setMode('connected');
  } catch (_a) {
    setStatusErrorMessage('An error occured, please retry');
  }
};

const onError = setFormErrorMessage => error => {
  switch (error) {
    case 'invalidState':
      setFormErrorMessage('Une erreur est survenue, veuillez réessayer');
      break;

    case 'userAccessDenied':
      setFormErrorMessage('Vous devez autoriser l’accès à votre compte Zendesk pour le connecter à Tolk Bot');
      break;

    case 'inexistingAccessToken':
      setFormErrorMessage('Impossible de se connecter à Zendesk, veuillez réessayer');
      break;
  }
};

const onSubmit = (window, subdomain, botId, createOneZendeskLoginConfig, setFormErrorMessage) => async event => {
  event.preventDefault();
  const state = uuid.v4();
  const result = await createOneZendeskLoginConfig(subdomain, botId, state);

  if (genericUtils.isDomainError(result, zendesk.appPorts.CreateOneZendeskLoginConfigErrors)) {
    switch (result) {
      case zendesk.appPorts.CreateOneZendeskLoginConfigErrors.emptySubdomain:
        setFormErrorMessage('Sub-domain cannot be empty');
        break;

      case zendesk.appPorts.CreateOneZendeskLoginConfigErrors.inexistingBot:
        setFormErrorMessage('Current bot does not exist');
        break;
    }

    return;
  }

  window.location.assign(result.url);
};

const onDisconnect = (deleteOneZendeskLoginConfigConnected, botId, setMode, setFormErrorMessage) => async event => {
  event.preventDefault();

  try {
    await deleteOneZendeskLoginConfigConnected(botId);
    setMode('disconnected');
  } catch (_a) {
    setFormErrorMessage('An error occured, please retry');
  }
};

const onSubdomainChange = setSubdomain => event => {
  setSubdomain(event.target.value);
};

const container = (createOneZendeskLoginConfig, getOneZendeskLoginConfigConnected, deleteOneZendeskLoginConfigConnected, window) => ({
  botId
}) => {
  const urlParameters = new URLSearchParams(window.location.search);
  const error = urlParameters.get('error');
  const [mode, setMode] = react.useState('disconnected');
  const [subdomain, setSubdomain] = react.useState('');
  const [statusErrorMessage, setStatusErrorMessage] = react.useState('');
  const [formErrorMessage, setFormErrorMessage] = react.useState('');
  react.useEffect(() => {
    if (error !== null) {
      void onError(setFormErrorMessage)(error);
      return;
    }

    void onInit(getOneZendeskLoginConfigConnected, setMode, setStatusErrorMessage)(botId);
  }, [botId, error]);
  return jsxs(Fragment, {
    children: [statusErrorMessage.length > genericUtils.ARRAY.EMPTY_LENGTH && jsx("p", {
      children: statusErrorMessage
    }, void 0), statusErrorMessage.length === genericUtils.ARRAY.EMPTY_LENGTH && jsx(Component, {
      errorMessage: formErrorMessage,
      mode: mode,
      onDisconnect: onDisconnect(deleteOneZendeskLoginConfigConnected, botId, setMode, setFormErrorMessage),
      onSubdomainChange: onSubdomainChange(setSubdomain),
      onSubmit: onSubmit(window, subdomain, botId, createOneZendeskLoginConfig, setFormErrorMessage),
      subdomain: subdomain
    }, void 0)]
  }, void 0);
};

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  container: container
});

export { index$3 as instagramLogin, index$2 as messengerLogin, index$1 as shopifyLogin, index as zendeskLogin };
